export default __webpack_public_path__ + "img/d9ead13e0290fa1c6b62adad933da52b.svg";